"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BottleneckStatusCell = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("@veeam/components");
const styled_components_1 = __importDefault(require("styled-components"));
const icons_1 = __importDefault(require("../../../../../../assets/icons"));
const helpers_1 = require("../../../../../../helpers");
require("./types");
const HowToFixLink_1 = require("./HowToFixLink");
const NowrapCell = styled_components_1.default.td `
  white-space: nowrap;
`;
exports.BottleneckStatusCell = react_1.default.memo(({ isWarning, warningText, successText, height = '33%', onHowToFixClick = helpers_1.noop }) => {
    return (react_1.default.createElement(NowrapCell, { height: height },
        react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.column, gap: components_1.STACK_GAP.xs },
            react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.row, distribution: components_1.STACK_DISTRIBUTION.start, gap: components_1.STACK_GAP.s, align: components_1.STACK_ALIGN.center },
                react_1.default.createElement(components_1.Icon, { size: components_1.ICON_SIZES.xl, src: isWarning ? icons_1.default.dashboard.warning : icons_1.default.dashboard.success }),
                react_1.default.createElement(components_1.Text, { size: components_1.TEXT_SIZE.xl }, isWarning ? warningText : successText)),
            isWarning && react_1.default.createElement(HowToFixLink_1.HowToFixLink, { onHowToFixClick: onHowToFixClick }))));
});
//# sourceMappingURL=BottleneckStatusCell.js.map